
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1wzqe_s2kz3_93",
  "search-field": "awsui_search-field_1wzqe_s2kz3_128",
  "input-wrapper": "awsui_input-wrapper_1wzqe_s2kz3_134",
  "add-token": "awsui_add-token_1wzqe_s2kz3_138",
  "tokens": "awsui_tokens_1wzqe_s2kz3_145",
  "token-operator": "awsui_token-operator_1wzqe_s2kz3_149",
  "property-editor": "awsui_property-editor_1wzqe_s2kz3_153",
  "token-editor": "awsui_token-editor_1wzqe_s2kz3_154",
  "property-editor-form": "awsui_property-editor-form_1wzqe_s2kz3_158",
  "token-editor-form": "awsui_token-editor-form_1wzqe_s2kz3_159",
  "property-editor-field-property": "awsui_property-editor-field-property_1wzqe_s2kz3_162",
  "token-editor-field-property": "awsui_token-editor-field-property_1wzqe_s2kz3_163",
  "property-editor-field-operator": "awsui_property-editor-field-operator_1wzqe_s2kz3_166",
  "token-editor-field-operator": "awsui_token-editor-field-operator_1wzqe_s2kz3_167",
  "property-editor-field-value": "awsui_property-editor-field-value_1wzqe_s2kz3_170",
  "token-editor-field-value": "awsui_token-editor-field-value_1wzqe_s2kz3_171",
  "property-editor-cancel": "awsui_property-editor-cancel_1wzqe_s2kz3_174",
  "token-editor-cancel": "awsui_token-editor-cancel_1wzqe_s2kz3_175",
  "property-editor-submit": "awsui_property-editor-submit_1wzqe_s2kz3_178",
  "token-editor-submit": "awsui_token-editor-submit_1wzqe_s2kz3_179",
  "property-editor-actions": "awsui_property-editor-actions_1wzqe_s2kz3_182",
  "token-editor-actions": "awsui_token-editor-actions_1wzqe_s2kz3_183",
  "custom-content-wrapper": "awsui_custom-content-wrapper_1wzqe_s2kz3_201",
  "custom-control": "awsui_custom-control_1wzqe_s2kz3_205",
  "input": "awsui_input_1wzqe_s2kz3_134",
  "results": "awsui_results_1wzqe_s2kz3_213",
  "token-trigger": "awsui_token-trigger_1wzqe_s2kz3_219",
  "remove-all": "awsui_remove-all_1wzqe_s2kz3_224",
  "token-label": "awsui_token-label_1wzqe_s2kz3_225",
  "join-operation": "awsui_join-operation_1wzqe_s2kz3_226",
  "custom-filter-actions": "awsui_custom-filter-actions_1wzqe_s2kz3_227"
};
  